import { BrandsLogos } from "./BrandsLogos";

export const OwnerManualsHeader = () => {
  return (
    <div className="flex w-full flex-wrap justify-between items-center pt-2 pb-2 ps-2">
      <h1 className="grow-[1] text-xl sm:text-3xl ms-1" style={{ color: "black" }}>
        Owner Manuals
      </h1>
      <BrandsLogos />
    </div>
  );
};
